/* @ngInject */
export default function ChangeInstitutionCtrl(
  $location,
  $state,
  $stateParams,
  CurrentUserManager,
  RailsRoutes,
  config,
) {
  const vm = this;

  vm.$state = $state;
  vm.$stateParams = $stateParams;
  vm.CurrentUserManager = CurrentUserManager;
  vm.RailsRoutes = RailsRoutes;
  vm.config = config;
  vm.calculateSwitchInstitutionLink = calculateSwitchInstitutionLink;


  function calculateSwitchInstitutionLink(institution) {
    if (vm.$stateParams.mobileapp) {
      return `${$location.protocol()}://${institution.host}/${vm.$state.href('dashboard')}`;
    }
    return `${$location.protocol()}://${institution.host}/${vm.$state.href('root')}`;
  }
}
